import { MenuItem, ListItemIcon, Menu } from "@mui/material";
import React from "react";
export const FMenu = ({ anchorEl, open, handleClose, menuItems, right = "50%", }) => {
    return (React.createElement(Menu, { anchorEl: anchorEl, id: "account-menu", open: open, onClose: handleClose, onClick: handleClose, PaperProps: {
            sx: {
                minWidth: 200,
            },
        }, style: {
        // boxShadow: " -20px 20px 40px -4px #919EAB3D, 0px 0px 2px 0px #919EAB3D",
        // boxShadow:" -20px 20px 40px -4px #919EAB3D,box-shadow: 0px 0px 2px 0px #919EAB3D"
        } }, menuItems.map((item, index) => (React.createElement(MenuItem, { key: index, sx: Object.assign({ color: item.color === "error" ? "error.main" : "inherit", "& svg": {
                color: item.color === "error" ? "error.main" : "inherit",
            } }, (item.sx || {})), onClick: item.onClick, disabled: item.disabled },
        item.icon && React.createElement(ListItemIcon, null, item.icon),
        item.label)))));
};
